import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';

export const haptics = {
    impact: async (style = ImpactStyle.Light) => {
        if (Capacitor.isNativePlatform()) {
            try {
                await Haptics.impact({ style });
            } catch (e) {
                console.warn('Haptics not available');
            }
        }
    },
    notification: async (type = 'SUCCESS') => {
        if (Capacitor.isNativePlatform()) {
            try {
                await Haptics.notification({ type });
            } catch (e) {
                console.warn('Haptics not available');
            }
        }
    },
    selectionStart: async () => {
        if (Capacitor.isNativePlatform()) {
            try {
                await Haptics.selectionStart();
            } catch (e) {
                console.warn('Haptics not available');
            }
        }
    },
    selectionChanged: async () => {
        if (Capacitor.isNativePlatform()) {
            try {
                await Haptics.selectionChanged();
            } catch (e) {
                console.warn('Haptics not available');
            }
        }
    },
    vibrate: async () => {
        if (Capacitor.isNativePlatform()) {
            try {
                await Haptics.vibrate();
            } catch (e) {
                console.warn('Haptics not available');
            }
        }
    }
};

export default haptics;
